// Libelles des fichiers joints : extension et taille lisible (« PDF, 340 Ko »).

export type FileSizeUnitsType = { b: string; kb: string; mb: string; gb: string }

type FormattableFileType = { name: string; ext?: string; size?: number | null }

// extension affichee sur la vignette : celle du fichier, sinon celle du nom
export function getExtensionLabel(file: FormattableFileType): string {
  const ext = (file.ext || file.name.split('.').pop() || '').replace(/^\./, '')
  return ext.slice(0, 4).toUpperCase()
}

export function formatFileSize(bytes: number, locale: string, units: FileSizeUnitsType): string {
  const steps: [number, string][] = [
    [1024 ** 3, units.gb],
    [1024 ** 2, units.mb],
    [1024, units.kb],
  ]
  for (const [factor, unit] of steps) {
    if (bytes >= factor) {
      const value = bytes / factor
      const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: value < 10 ? 1 : 0 }).format(value)
      return `${formatted} ${unit}`
    }
  }
  return `${new Intl.NumberFormat(locale).format(bytes)} ${units.b}`
}

// « PDF, 340 Ko » ; sans taille connue (fichiers anciens), l'extension seule
export function formatFileDescription(file: FormattableFileType, locale: string, units: FileSizeUnitsType): string {
  const ext = getExtensionLabel(file)
  if (typeof file.size !== 'number' || file.size < 0) return ext
  return [ext, formatFileSize(file.size, locale, units)].filter(Boolean).join(', ')
}
